module.exports = __webpack_public_path__ + "static/media/Polygon.6f8d7475.svg";